import React, { forwardRef, useState, useRef, useImperativeHandle, useMemo } from "react";
import { FORM_ACTIONS } from "../../FormActions";
import styles from "./CustomReportsForm.module.sass";
import HeadersTab from "./Tabs/HeadersTab";
import { TabSelector } from "../../../../components/index";
import CommandsTab from "./Tabs/CommandsTab";
import ConfigsTab from "./Tabs/ConfigsTab";
import PackageDropdownMultiSelector from "../../Packages/PackageDropdownMultiSelector/PackageDropdownMultiSelector";

const CustomReportSettingsForm = (props, ref) => {
    const { data, status, onChange, onSave, classifiers, querySelectors, packages } = props;
    const {
        id,
        ReportName,
        Active,
        Content,
        DefaultCondition,
        Configs,
        Metadata,
        Packages: selectedPackages,
    } = data || {};

    const [contentFormatted, setContentFormatted] = useState("");
    const [selected, setSelected] = useState(0);
    const formRef = useRef();
    const formTabs = ["Headers", "Commands", "Configurations", "Packages"];

    useImperativeHandle(ref, () => ({
        submit: () => {
            formRef.current.dispatchEvent(new Event("submit", { cancelable: true, bubbles: true }));
        },
    }));

    useMemo(() => {
        try {
            if (Content) {
                setContentFormatted(JSON.stringify(JSON.parse(Content))||"");
            }
        } catch (e) {
            console.log(e);
        }
    }, [Content]);

    function statusCheck(modalStatus) {
        return modalStatus !== "loading";
    }

    const handleChange = (e, prop, value) => {
        onChange &&
            onChange({
                originalEvent: e,
                target: {
                    value: {
                        data: {
                            ...data,
                            [prop]: value,
                        },
                    },
                },
            });
    };

    const handleConfigsChange = (e, key, value, index, array) => {
        array[index][`${key}`] = value;
        onChange &&
            onChange({
                originalEvent: e,
                target: {
                    value: {
                        data: {
                            ...data,
                            Configs: JSON.stringify([...(array || [])]),
                        },
                    },
                },
            });
    };

    return statusCheck(status) ? (
        <form
            ref={formRef}
            onSubmit={(e) => {
                e.stopPropagation();
                e.preventDefault();
                if (formRef.current.checkValidity()) {
                    data["Content"] = contentFormatted;
                    onSave && onSave();
                } else {
                    formRef.current.reportValidity();
                }
            }}
        >
            <TabSelector tabs={formTabs} selected={selected} setSelected={setSelected} />
            <div className={`${styles["inputs"]} ${styles[`visible-${selected}`]}`}>
                <HeadersTab
                    ReportName={ReportName ||""}
                    Active={Active || false}
                    Metadata={Metadata || ""}
                    DefaultCondition={DefaultCondition || ""}
                    handleChange={handleChange}
                />
                <CommandsTab
                    Content={contentFormatted || ""}
                    Metadata={Metadata || ""}
                    querySelectors={querySelectors || ""}
                    handleChange={handleChange}
                />
                <ConfigsTab
                    Config={Configs  || ""}
                    Classifiers={classifiers || ""}
                    handleConfigsChange={handleConfigsChange}
                    handleChange={handleChange}
                />
                <PackageDropdownMultiSelector
                    packages={packages || ""}
                    selectedPackages={selectedPackages || ""}
                    handleChange={handleChange}
                    entitieID={id || ""}
                    containerTitle={"Packages Association"}
                    entitieKey={"workerTypeId"}
                />
            </div>
        </form>
    ) : null;
};

const CustomReportSettingsFormRef = forwardRef(CustomReportSettingsForm);

CustomReportSettingsFormRef.queries = (args) => {
    return [
        {
            resource: "classifiers",
            args: {
                locale: args.locale,
            },
            body: `
            level{id, name},
            appliesTo{id, name, config},
			      `,
        },
        {
            resource: "query_selectors",
            body: "items{id, name}",
        },
        {
            resource: "getPackages",
            body: "id,name",
        },
        args && args.id
            ? {
                resource: "custom_report",
                args: {
                    customReportId: args.id,
                },
                body: "__typename,id,ReportName,Content,DefaultCondition,Active,Metadata, Configs, Packages{id, packageId, workerTypeId}",
            }
            : undefined,
    ].filter((q) => q);
};

CustomReportSettingsFormRef.dataMapper = ["classifiers", "querySelectors", "packages", "data"];

CustomReportSettingsFormRef.actions = [FORM_ACTIONS.SAVE];

export default CustomReportSettingsFormRef;
